import {inject, injectable} from 'inversify';

import {BaseDomainFactory} from '../../../core/domain/Base/BaseDomain.factory';
import {ModelsRegistry} from '../../system/modelsRegistry/ModelsRegistry';
import {MetricModel} from './Metric.model';

@injectable()
export class MetricFactory
  implements BaseDomainFactory<MetricModel, MetricModel.Props>
{
  constructor(
    @inject(ModelsRegistry)
    private readonly modelsRegistry: ModelsRegistry,
  ) {}

  create(props: MetricModel.Props): MetricModel {
    return this.modelsRegistry.put(new MetricModel(props));
  }
}
